import { useContext, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useShallow } from 'zustand/react/shallow';

import { getGeoLocationFromStorage } from '../../common/PSXHeader/SearchBar/utils';
import { SearchFilterContext } from '../../context/SearchFilterContext';
import { useTypeaheadStore } from '../../store/useTypeaheadStore';

export const useGeoLocationStorage = () => {
  const [, setSearchParams] = useSearchParams();
  const [geoLocation, setGeoLocation] = useState(getGeoLocationFromStorage());
  const { clearSearchFilters } = useContext(SearchFilterContext);
  const { setTypeaheadSearchStore } = useTypeaheadStore(
    useShallow((state: any) => ({
      setTypeaheadSearchStore: state.setTypeaheadSearchStore,
    }))
  );
  useEffect(() => {
    const getGeoLocation = () => {
      const newGeoLocation = getGeoLocationFromStorage();
      clearSearchFilters();
      // remove searchRadius from url and set isTypeaheadStoreValuesSet to false whenever location is changed.
      // set isDeeplinkAutoSearchRadiusQueryDone to false when location changes to trigger auto search radius query again.
      setSearchParams(
        (searchParams) => {
          if (searchParams.get('isDeeplinkAutoSearchRadiusQueryDone')) {
            searchParams.set('isDeeplinkAutoSearchRadiusQueryDone', 'false');
          }
          searchParams.delete('searchRadius');
          return searchParams;
        },
        { replace: true }
      );
      const urlParams = new URLSearchParams(window.location.search);
      const isExternalMapViewLink =
        !!urlParams.get('sectionType') && !urlParams.get('psxSource');
      if (!isExternalMapViewLink) {
        setTypeaheadSearchStore({ isTypeaheadStoreValuesSet: false });
      }
      setGeoLocation(newGeoLocation);
    };
    window.addEventListener('updateGeoLocationToStorage', getGeoLocation);
    return () => {
      window.removeEventListener('updateGeoLocationToStorage', getGeoLocation);
    };
  }, [clearSearchFilters]);

  return geoLocation;
};
